import {TabsNavigation as PeacockTabsNavigation} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').ITabsNavigationProps} TabsNavigationProps
 * @property {import('react').ReactNode} [children] Tab items rendered inside navigation.
 * @property {boolean} [disabled] When true, tabs navigation is rendered in disabled mode.
 * @property {(newIndex: number) => void} [onUpdate] Callback invoked when selected tab changes.
 * @property {number} [selectedIndex] Active tab index.
 * @property {'horizontal' | 'vertical'} [orientation] Tabs orientation.
 * @property {'line' | 'shadow' | 'border'} [type] Tabs visual type.
 * @property {number} [maxVisibleTabs] Maximum visible tabs before overflow dropdown.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS TabsNavigation.
 * Supports all Peacock DS tabs navigation props.
 * @param {TabsNavigationProps} props
 */
export const TabsNavigation = props => {
  const {children, ...restProps} = props

  return <PeacockTabsNavigation {...restProps}>{children}</PeacockTabsNavigation>
}
